import React from "react";
import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import WhyChoos from "./components/WhyChoos";
import Benner from "./components/Benner";
import Products from "./pages/products/Products";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import CartPage from "./pages/products/Card";
import ShippingPolicy from "./pages/policies/ShippingPolicy";
import ReturnPolicy from "./pages/policies/ReturnPolicy";
import RefundPolicy from "./pages/policies/RefundPolicy";
import WarrantyPolicy from "./pages/policies/WarrantyPolicy";
import PrivacyPolicy from "./pages/policies/PrivacyPolicy";
import FAQ from "./pages/others/Faqs";
import TermsConditions from "./pages/policies/TermsConditions";
import Footer from "./components/Footer";
import ProductDetails from "../src/pages/products/Productcard2";
// import HeroProductView from "./components/Hero/HeroProductView";
import Services from "./pages/Services/Services";
import Login from "./pages/user/Login";
import Logout from "./pages/user/Logout";
import Profile from "./pages/user/Profile";
import Registation from "./pages/user/Registration";
import Password from "./pages/user/Password";
import OtpVerify from "./pages/user/OtpVerify";
import Scrollup from "./components/Scrollup";
import ScrollToTop from "./components/ScrollToTop";
import Checkout from "./pages/chekout/Checkout";
import GatewayMyProfile from "./pages/gateway/MyProfile";
import GatewayMyOrder from "./pages/gateway/MyOrder";
import GatewayMyOrderDetails from "./pages/gateway/MyorderDetails";



const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/whychoose" element={<WhyChoos />} />
        <Route path="/benner" element={<Benner />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />

        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/myprofile" element={<GatewayMyProfile />} />
        <Route path="/myorder" element={<GatewayMyOrder />} />
        <Route path="/myorderdetails/:id" element={<GatewayMyOrderDetails />} />
        <Route path="/registation" element={<Registation />} />
        <Route path="/password" element={<Password />} />
        <Route path="/verify-otp" element={<OtpVerify />} />


        {/* 🔹 CART ROUTE */}
        <Route path="/cart" element={<CartPage />} />

        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/refund-cancellation-policy" element={<RefundPolicy />} />
        <Route path="/warranty-policy" element={<WarrantyPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/products2/:id" element={<ProductDetails />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/checkout" element={<Checkout />} />
{/* <Route path="/hero-product/:id" element={<HeroProductView />} /> */}
      </Routes>

      <Footer />
        <Scrollup />
    </Router>
  );
};

export default App;
